<template>
  <vx-card title="Kunden & Betrieb">
    <div class="flex flex-wrap -mx-2">
      <div
        v-for="stat in stats"
        :key="stat.label"
        class="w-1/2 lg:w-1/5 px-2 text-center mb-4 lg:mb-0"
      >
        <h2 class="font-bold" :class="stat.colorClass">{{ stat.value }}</h2>
        <p class="text-sm text-grey mt-1">{{ stat.label }}</p>
      </div>
    </div>
  </vx-card>
</template>

<script>
export default {
  name: "AnalyticsCustomerAndOps",
  props: {
    customerData: { type: Object, required: true },
    opsData: { type: Object, required: true },
  },
  computed: {
    stats() {
      return [
        {
          label: "Kunden gesamt",
          value: this.customerData.totalUsers,
          colorClass: "text-primary",
        },
        {
          label: "Neu diese Woche",
          value: this.customerData.newCustomersThisWeek,
          colorClass: "text-success",
        },
        {
          label: "Wiederkehrrate",
          value: (this.customerData.repeatRate * 100).toFixed(1) + "%",
          colorClass: "text-primary",
        },
        {
          label: "Ø Bearbeitungszeit",
          value: this.opsData.avgFulfillmentMinutes + " Min",
          colorClass: "text-success",
        },
        {
          label: "Kontaktanfragen (7d)",
          value: this.opsData.contactFormsLastWeek,
          colorClass: "text-primary",
        },
      ];
    },
  },
};
</script>
